<!-- Add filter option -->
<div class="add-filter-container">
  <div *ngIf="isShowAddMoreFilter && isShowAddMoreFilterSection" class="filter-addmore-section d-flex flex-row justify-content-end">
    <button  type="button" class="btn btn-primary btn-reset-filter" (click)="onResetFilter(); onMixpanelTrackingResetAddMoreFilter()">Reset filters</button>
    <button *ngIf="isAddMoreFilter" type="button" class="btn btn-primary btn-close-filter" (click)="onClose(); onMixpanelTrackingAddmorefilterClick(false)">Close</button>
    <button *ngIf="!isAddMoreFilter" type="button" class="btn btn-primary btn-addmore-filter" (click)="onAddMoreFilter(); onMixpanelTrackingAddmorefilterClick(true)">Add More filters</button>
  </div>
</div>

<div [class]="'filter-section even-wrapper'">
  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.BOTTLERS_EN"
    dataTitle="Bottler"
    dataDescription="Bottler"
    keyName="BOTTLERS_EN"
    [sectionName]="sectionName"
    [initialData]="lstOptions.BOTTLERS_EN"
    [initialSelected]="lstOption_Selected.BOTTLERS_EN"
    [initialState]="lstOption_States.BOTTLERS_EN"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.SALES_ORG_EN"
    dataTitle="Sales Area"
    dataDescription="Sales Area"
    keyName="SALES_ORG_EN"
    [sectionName]="sectionName"
    [initialData]="lstOptions.SALES_ORG_EN"
    [initialSelected]="lstOption_Selected.SALES_ORG_EN"
    [initialState]="lstOption_States.SALES_ORG_EN"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.SALES_SUBORG_EN"
    dataTitle="Sales District"
    dataDescription="Sales District"
    keyName="SALES_SUBORG_EN"
    [sectionName]="sectionName"
    [initialData]="lstOptions.SALES_SUBORG_EN"
    [initialSelected]="lstOption_Selected.SALES_SUBORG_EN"
    [initialState]="lstOption_States.SALES_SUBORG_EN"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.CHANNEL_LEV1"
    dataTitle="Channel Lev1"
    dataDescription="Channel Lev1"
    keyName="CHANNEL_LEV1"
    [sectionName]="sectionName"
    [initialData]="lstOptions.CHANNEL_LEV1"
    [initialSelected]="lstOption_Selected.CHANNEL_LEV1"
    [initialState]="lstOption_States.CHANNEL_LEV1"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.CHANNEL_LEV2"
    dataTitle="Channel Lev2"
    dataDescription="Channel Lev2"
    keyName="CHANNEL_LEV2"
    [sectionName]="sectionName"
    [initialData]="lstOptions.CHANNEL_LEV2"
    [initialSelected]="lstOption_Selected.CHANNEL_LEV2"
    [initialState]="lstOption_States.CHANNEL_LEV2"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.MCI_MAIN_9_CATEGORY"
    dataTitle="Category"
    dataDescription="Category"
    keyName="MCI_MAIN_9_CATEGORY"
    [sectionName]="sectionName"
    [initialData]="lstOptions.MCI_MAIN_9_CATEGORY"
    [initialSelected]="lstOption_Selected.MCI_MAIN_9_CATEGORY"
    [initialState]="lstOption_States.MCI_MAIN_9_CATEGORY"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.MCI_SUBCATEGORY"
    dataTitle="Sub Category"
    dataDescription="Sub Category"
    keyName="MCI_SUBCATEGORY"
    [sectionName]="sectionName"
    [initialData]="lstOptions.MCI_SUBCATEGORY"
    [initialSelected]="lstOption_Selected.MCI_SUBCATEGORY"
    [initialState]="lstOption_States.MCI_SUBCATEGORY"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.MCI_PKG_LEV1"
    dataTitle="Package Lev1"
    dataDescription="Package Lev1"
    keyName="MCI_PKG_LEV1"
    [sectionName]="sectionName"
    [initialData]="lstOptions.MCI_PKG_LEV1"
    [initialSelected]="lstOption_Selected.MCI_PKG_LEV1"
    [initialState]="lstOption_States.MCI_PKG_LEV1"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.MCI_PKG_LEV2"
    dataTitle="Package Lev2"
    dataDescription="Package Lev2"
    keyName="MCI_PKG_LEV2"
    [sectionName]="sectionName"
    [initialData]="lstOptions.MCI_PKG_LEV2"
    [initialSelected]="lstOption_Selected.MCI_PKG_LEV2"
    [initialState]="lstOption_States.MCI_PKG_LEV2"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.PKG_LEV3"
    dataTitle="Package Lev3"
    dataDescription="Package Lev3"
    keyName="PKG_LEV3"
    [sectionName]="sectionName"
    [initialData]="lstOptions.PKG_LEV3"
    [initialSelected]="lstOption_Selected.PKG_LEV3"
    [initialState]="lstOption_States.PKG_LEV3"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.MCI_MAIN_5_MAKER"
    dataTitle="Maker"
    dataDescription="Maker"
    keyName="MCI_MAIN_5_MAKER"
    [sectionName]="sectionName"
    [initialData]="lstOptions.MCI_MAIN_5_MAKER"
    [initialSelected]="lstOption_Selected.MCI_MAIN_5_MAKER"
    [initialState]="lstOption_States.MCI_MAIN_5_MAKER"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>

  <multi-dropdown-tag *ngIf="lstOption_IsUsed?.BRAND_EN"
    dataTitle="Brand"
    dataDescription="Brand"
    keyName="BRAND_EN"
    [sectionName]="sectionName"
    [initialData]="lstOptions.BRAND_EN"
    [initialSelected]="lstOption_Selected.BRAND_EN"
    [initialState]="lstOption_States.BRAND_EN"
    [showTooltip]="false"
    (saveItemsChange)="onSaveItemsChange($event)"
    (convertTentativeToEnableTemp)="onConvertTentativeToEnableTemp($event)"
    (convertEnableTempToTentative)="onConvertEnableTempToTentative($event)"></multi-dropdown-tag>
</div>

<!-- <div class="d-flex justify-content-center">
  <button type="button" class="btn btn-primary" (click)="updateChart(); onMixpanelTracking()">Apply</button>
</div> -->
